import { RequestLog } from '@engine/models'

interface TenderStatusBadgeProps {
  log: RequestLog
}

const TenderStatusBadge = ({ log }: TenderStatusBadgeProps) => {
  const pickup = log.tenantResponse?.content?.pickup

  if (!pickup?.status) {
    return <span className="text-xs opacity-50">N/A</span>
  }

  const statusLower = pickup.status.toLowerCase()
  let badgeClass = 'badge-neutral'
  let displayText = pickup.status

  if (statusLower === 'ok') {
    badgeClass = 'badge-success'
  } else if (statusLower === 'error') {
    badgeClass = 'badge-error'
    const errorType = pickup.errorType
    if (errorType) {
      displayText = errorType
    }
  } else if (statusLower === 'pending') {
    badgeClass = 'badge-warning'
  }

  return <span className={`badge badge-sm ${badgeClass}`}>{displayText}</span>
}

export { TenderStatusBadge }
